import React, { createContext, useContext, useEffect, useState } from 'react';

const QuoteCartContext = createContext(null);
const KEY = 'cf_quote_cart';

export function QuoteCartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem(KEY);
    if (raw) { try { setItems(JSON.parse(raw)); } catch (e) { /* ignore */ } }
  }, []);

  const persist = (next) => { setItems(next); localStorage.setItem(KEY, JSON.stringify(next)); };

  const addItem = (item, openDrawer = true) => {
    const key = `${item.productId}::${item.sku || ''}`;
    const exists = items.some((i) => `${i.productId}::${i.sku || ''}` === key);
    if (exists) { if (openDrawer) setOpen(true); return false; }
    persist([...items, { ...item, qty: 1 }]);
    if (openDrawer) setOpen(true);
    return true;
  };

  const removeItem = (productId, sku) => persist(items.filter((i) => !(i.productId === productId && (i.sku || '') === (sku || ''))));
  const setQty = (productId, sku, qty) => persist(items.map((i) => (i.productId === productId && (i.sku || '') === (sku || '') ? { ...i, qty: Math.max(1, qty) } : i)));
  const clear = () => persist([]);

  return (
    <QuoteCartContext.Provider value={{ items, count: items.length, open, setOpen, addItem, removeItem, setQty, clear }}>
      {children}
    </QuoteCartContext.Provider>
  );
}

export function useQuoteCart() {
  const ctx = useContext(QuoteCartContext);
  if (!ctx) throw new Error('useQuoteCart must be used within QuoteCartProvider');
  return ctx;
}
